import React from "react";
import { Layout } from "antd";

import HeaderMenu from "../../HeaderMenu/HeaderMenu";
import FlowTable from "./FlowTable";
import { PageHeader } from "@ant-design/pro-layout";
const { Content } = Layout;

const FlowTablePage = () => {
  return (
    <>
      <HeaderMenu>
        <PageHeader title={<h1>Flows</h1>} />
      </HeaderMenu>

      <Content
        style={{
          height: "calc(100vh - 64px)",
          overflowY: "hidden",
          position: "relative",
        }}
      >
        <FlowTable />
      </Content>
    </>
  );
};

export default FlowTablePage;
